import { HTMLTable, Spinner } from '@blueprintjs/core';
import * as React from 'react';
import styled from 'react-emotion';
import { connect } from 'react-redux';
import firebase from '../firebase';
import { firestore } from '../firebase';
import { IState } from '../store';


const InventoryContainer = styled('div')`
  /* overflow: auto; */
  flex-direction: row;
  /* position: fixed; */
  /* align-items: center;
  justify-content: center; */
  /* left: 50%; */
  height: 100%;
`;
const TableContainer = styled('div')`
  align-items: center;
  justify-content: center;
  /* left: 25%; */
  flex: 3;
  /* overflow: auto; */
`;

const getPriceTable= firebase
.functions()
.httpsCallable('getPricesTable');


class PricesTable extends React.PureComponent<any, any>{
  public weekAgo = Date.now() - 604800000;
  public dayAgo = Date.now() - 86400000;

  public batchIncrement = 400;
  public batchStart = 0;
  public batchSize = 0;

  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      make: '',
      model: '',
      parts: [],
      rows: [],
      search: [],
      yearMax: null,
      yearMin: null,
    };
  }

  public async componentDidMount() {
    const params = this.props.match.params;
    if(params.business){
        const query = await firestore.collection('businesses').where('path', '==', params.business).get();
        const businessDoc = query.docs[0].data();
          if(params.site && params.site !== '-'){
              const siteQuery = await query.docs[0].ref.collection('sites').where('path', '==', params.site).get();
              const siteDoc = siteQuery.docs[0].data();
              this.setState({s3Id: siteDoc.s3Id});
          } else {
              this.setState({s3Id: businessDoc.s3Id});
          }
          this.queryPriceTable();
    }
  }

  public render() {
    const { parts } = this.state;
    if(parts.length === 0){
        return (
            <InventoryContainer>
                <Spinner />
            </InventoryContainer>
        );
    }
    return (
      <InventoryContainer>
        <TableContainer>
            <input placeholder={'Find part'} onChange={(event) => this.handleSearchChange(event.target.value)} />
          <HTMLTable>
            <thead>
              <tr>
                <th>Part</th>
                <th>Price</th>
                <th>Core</th>
              </tr>
            </thead>
            <tbody>
              {this.state.rows.map((data, index) => {
                return this.renderPartRow(data, index);
              })}
            </tbody>
          </HTMLTable>
        </TableContainer>
      </InventoryContainer>
    );
  }
  private handleSearchChange = async ( search ) => {
      if(search === ""){
          this.setState({rows: this.state.parts})
      } else {
        console.log(search);
        const rows = this.state.parts.filter(part => part.PartName[0].toUpperCase().includes(search.toUpperCase()));
        this.setState({ rows })
      }
  }

  private queryPriceTable = async () => {
      console.log("querying price table...");
      const { s3Id } = this.state;
      const priceTable = await getPriceTable({s3Id});
      console.log(priceTable);
      this.setState({parts: priceTable.data, rows: priceTable.data});
  }

  private renderPartRow = (part, index) => {
    const partName = part.PartName[0];
    const price = '$' + part.PartPrice[0];
    const core = '$' + part.CorePrice[0];


      return (
          <tr key={index}>
            <td>{ partName }</td>
            <td>{ price }</td>
            <td>{ core }</td>
          </tr>
      )
  }
}

const mapStateToProps = ({ inventory: { vehicles } }: IState) => ({ vehicles });

const mapDispatchToProps = {
};

export default connect<any, any>(
  mapStateToProps,
  mapDispatchToProps,
)(PricesTable);




// WEBPACK FOOTER //
// ./src/views/PricesTable.tsx